import React from 'react';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import GradientCard from '../gamification/GradientCard';
import { authProviderLabel } from '../../utils/authProviders';
import type { SecuritySettings } from '../../types/settings';

interface SsoManagedNoticeProps {
  provider: SecuritySettings['auth_provider'];
}

/**
 * Shown instead of the password form when the account signs in via an external
 * identity provider (SSO). Password and security are owned by that provider, so
 * we surface a friendly, provider-named explanation rather than a disabled form.
 */
const SsoManagedNotice: React.FC<SsoManagedNoticeProps> = ({ provider }) => {
  const label = authProviderLabel(provider);

  return (
    <GradientCard className="p-6" overlayOpacity="opacity-20 dark:opacity-25" role="status">
      <div className="flex items-start gap-4">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600 dark:bg-primary-900/40 dark:text-primary-350">
          <LockClosedIcon className="h-5 w-5" aria-hidden="true" />
        </div>
        <div className="min-w-0">
          <h3 className="text-base font-semibold text-text-primary">
            Access and security managed by {label}
          </h3>
          <p className="mt-1 text-sm leading-relaxed text-text-secondary">
            You sign in with {label}, so your password and security settings are handled there. To
            update them, visit your {label} account settings.
          </p>
        </div>
      </div>
    </GradientCard>
  );
};

export default SsoManagedNotice;
